/**
 * Welle 12 (pre123): OS-Benachrichtigungen zu einem Call schließen, sobald er
 * erledigt ist (angenommen/abgelehnt/abgebrochen) — egal wo angenommen wurde.
 * Der Service Worker zeigt sie mit tag `call-<id>` und requireInteraction, also
 * bleiben sie sonst stehen. Schließt zusätzlich die Vorab-Benachrichtigung.
 */
export function closeCallNotifications(callId?: string): void {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then(async (reg) => {
      const all = await reg.getNotifications();
      for (const n of all) {
        if (n.tag === 'prenotif' || !callId || n.tag === `call-${callId}`) n.close();
      }
    })
    .catch(() => { /* SW evtl. nicht aktiv */ });
}
